import { processAPIResponse } from '@/utils/request';
import { fetchApiKeyScopesRequest, fetchApiKeysRequest } from '@/services/api/apiKey';

const initialState = {
  list: [],
  scopes: [],
  drawer: {
    visible: false,
    apiKey: null,
    mode: 'create' as 'create' | 'edit',
  },
  generatedKey: null,
};

export default {
  namespace: 'apiKeys',

  state: initialState,

  effects: {
    *fetchList(_, { call, put }) {
      const { response, data } = yield call(fetchApiKeysRequest);
      yield processAPIResponse({ response, data }, {
        *onSuccess(data) {
          yield put({ type: 'saveList', payload: data.data || data });
        },
      });
    },

    *fetchScopes(_, { call, put }) {
      const { response, data } = yield call(fetchApiKeyScopesRequest);
      yield processAPIResponse({ response, data }, {
        *onSuccess(data) {
          yield put({ type: 'saveScopes', payload: data.data || data });
        },
      });
    },

  },

  reducers: {
    saveList(state, { payload }) {
      return { ...state, list: payload };
    },
    saveScopes(state, { payload }) {
      return { ...state, scopes: payload };
    },
    openDrawer(state, { payload }) {
      return {
        ...state,
        drawer: {
          visible: true,
          apiKey: payload?.apiKey || null,
          mode: payload?.mode || 'create',
        },
        generatedKey: null,
      };
    },
    closeDrawer(state) {
      return {
        ...state,
        drawer: { visible: false, apiKey: null, mode: 'create' },
      };
    },
    setGeneratedKey(state, { payload }) {
      return { ...state, generatedKey: payload };
    },
    clearGeneratedKey(state) {
      return { ...state, generatedKey: null };
    },
  },
};
